var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',[_c('mod-detail-tabs',{attrs:{"mod":_vm.mod,"item-id":_vm.parent.item.id}}),_vm._v(" "),_c('base-listing',_vm._b({},'base-listing',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }